const init = () => {
    videoControlsInit();
    globalClickListener();
    window.resize(() => {
        mobileAccordion();
    });
    mobileAccordion();
    a11yFixes();
    menuUpdates();
    reviewCustomization();
    closeAnnouncement();
    scrollBehavior();
    fastSimonWidgetUpdates();
    judgeMeUpdates();
    cardLinks();
    breadcrumbUpdates();
    searchButton();
};
const a11yFixes = () => {
    const links = document.querySelectorAll('a[target="_blank"]:not([aria-label*="new window"])');
    if (links) {
        links.forEach((link, ind) => {
            link.setAttribute('aria-label', `${link.textContent.trim()} opens in a new window`);
        });
    }
};
const mobileAccordion = () => {
    const isDesktop = window.screen.width >= 750;
    const specific = isDesktop ? ':not([open])' : '[open]';
    const mobileAccordions = document.querySelectorAll(`.mobile-accordion${specific}`);
    if (mobileAccordions.length) {
        mobileAccordions.forEach(el => {
            if (isDesktop) {
                el.setAttribute('open', '');
            }
            else {
                el.removeAttribute('open');
            }
        });
    }
};
const globalClickListener = () => {
    document.body.addEventListener('click', function (e) {
        const target = e.target;
        if (window.screen.width < 800) {
            if (target.classList.contains('footer-block__heading')) {
                const dropdownEl = target.closest('.footer-block-content');
                const isOpen = dropdownEl.classList.contains('open');
                if (isOpen) {
                    dropdownEl.classList.remove('open');
                } else {
                    dropdownEl.classList.add('open');
                }
            }
        }
        readMore(target, e);
    });
};
const readMore = (target, e) => {
    if (target.classList.contains('read-more')) {
        e.preventDefault();
        target.closest('.read-more-container').classList.add('expanded');
    }
    if (target.classList.contains('read-more-btn')) {
        e.preventDefault();
        const readMoreContainer = target.closest('.read-more-container');
        if (readMoreContainer.classList.contains('expanded')) {
            readMoreContainer.classList.remove('expanded');
        }
        else {
            readMoreContainer.classList.add('expanded');
        }
    }
};
const videoControlsInit = () => {
    let isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const videoToggles = [...document.querySelectorAll('.utility-btn')];
    if (videoToggles.length !== 0) {
        videoToggles.forEach((videoToggle) => {
            const video = videoToggle.parentElement.querySelector('video');
            if (!!video) {
                videoToggle.addEventListener('click', function (e) {
                    e.preventDefault();
                    const videoEl = this.parentElement.querySelector('video');
                    const videoPlay = videoEl.paused || videoEl.ended;
                    videoEl.controls = 0;
                    if (videoPlay) {
                        videoEl.play();
                        videoEl.classList.add('keep-playing');
                        videoEl.parentElement.classList.add('playing');
                        videoToggle.setAttribute('aria-label', 'pause video');
                        videoToggle.classList.add('active');
                    } else {
                        videoEl.pause();
                        videoEl.classList.remove('keep-playing');
                        videoEl.parentElement.classList.remove('playing');
                        videoToggle.setAttribute('aria-label', 'play video');
                        videoToggle.classList.remove('active');
                    }
                });
                video.classList.add('keep-playing');
                if (isMobileDevice) {
                    video.pause();
                    video.classList.remove('keep-playing');
                    video.parentElement.classList.remove('playing');
                    videoToggle.setAttribute('aria-label', 'play video');
                    videoToggle.classList.remove('active');
                }
            }
        });
        const videos = document.querySelectorAll('video');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const videoEl = entry.target;
                const isPlay = videoEl.paused && videoEl.classList.contains('keep-playing');
                const isPause = entry.intersectionRatio === 0 && !videoEl.paused;
                if (isPause) {
                    videoEl.pause();
                    videoEl.parentElement.classList.remove('playing');
                    let toggle = videoEl.parentElement.querySelector('.utility-btn');
                    toggle.setAttribute('aria-label', 'play video');
                    toggle.classList.remove('active');
                } else if (isPlay) {
                    videoEl.play();
                    videoEl.parentElement.classList.add('playing');
                    let toggle = videoEl.parentElement.querySelector('.utility-btn');
                    toggle.setAttribute('aria-label', 'pause video');
                    toggle.classList.add('active');
                }
            });
        });
        videos.forEach((video) => {
            observer.observe(video);
        });
    }
};

const menuUpdates = () => {
    const list = document.querySelector(".header__submenu--large");
    if (!list) return;

    const detailsList = list.querySelectorAll("details");

    detailsList.forEach((detail, index) => {
        const summary = detail.querySelector("summary");

        detail.addEventListener("toggle", function () {
            if (detail.open) {
                detailsList.forEach((otherDetail) => {
                    if (otherDetail !== detail && otherDetail.open) {
                        otherDetail.open = false;
                        const otherSummary = otherDetail.querySelector("summary");
                        if (otherSummary) {
                            otherSummary.setAttribute("aria-expanded", "false");
                        }
                    }
                });
                if (summary) summary.setAttribute("aria-expanded", "true");
            } else {
                if (summary) summary.setAttribute("aria-expanded", "false");
            }
        });
    });
};

const reviewCustomization = () => {
    const interval = setInterval(() => {
        const badge = document.querySelector('.product__text ~ .shopify-app-block');
        if (badge) {
            clearInterval(interval);
            badge.insertAdjacentHTML('beforeend', `
            <a href="#reviews-summary" class="jdgm-custom-link">Write a Review</a>
            <a href="#reviews-summary" class="jdgm-custom-link">View All Reviews</a>
            `);

            badge.querySelectorAll('a').forEach(link => {

                link.addEventListener('click', (e) => {
                    const target = document.querySelector('#reviews-summary');
                    const details = target.querySelector('details');
                    const summary = details.querySelector('summary');
                    if (details) {
                        details.open = true;
                        summary.setAttribute('aria-expanded', 'true');
                    }
                });
            });
        }
    }, 100);
};

const closeAnnouncement = () => {
    const utilityBar = document.querySelector(".utility-bar");
    const closeBtn = document.querySelector(".announcement-bar__button");

    if (!sessionStorage.getItem("utilityBarClosed") && utilityBar) {
        utilityBar.classList.add("utility-bar--visible");
    }

    closeBtn?.addEventListener("click", function () {
        utilityBar.classList.remove("utility-bar--visible");
        sessionStorage.setItem("utilityBarClosed", "true");
    });
};

const scrollBehavior = () => {
    const header = document.querySelector(".header-wrapper");

    if (window.scrollY > 0) {
        header.classList.add("scrolled");
    } else {
        header.classList.remove("scrolled");
    }

  // Run on scroll
  window.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
        header.classList.add("scrolled");
    } else {
        header.classList.remove("scrolled");
    }
  });
};

const fastSimonWidgetUpdates = () => {
    const widgetHost = document.querySelector('[data-settings="FAST_UPSELL_CONFIG"]');
    const cartContainer = document.querySelector('main[data-template="cart"]');

    if(!cartContainer) return;

    if (widgetHost && widgetHost.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
            .fs-recommendation-widget-title.fs-rec-widget-1th4y2o {
                display: block;
                -webkit-box-orient: unset;
                -webkit-line-clamp: unset;
                overflow: visible;
                word-break: normal;
                overflow-wrap: normal;
                line-height: 1.3;
            }
        `;
        widgetHost.shadowRoot.appendChild(style);
    } else {
        console.warn('Widget host not found or shadowRoot is closed.');
    }
}

const judgeMeUpdates = () => {
    const pdpContainer = document.querySelector('main[data-template="product"]');

    if (pdpContainer) {
        const observer = new MutationObserver(() => {
            let unpatchedFound = false;

            pdpContainer.querySelectorAll('.jdgm-rev__author-wrapper').forEach(el => {
                if (!el.hasAttribute('role')) {
                    el.setAttribute('role', 'heading');
                    el.setAttribute('aria-level', '3');
                    unpatchedFound = true;
                }
            });

            pdpContainer.querySelectorAll('.jdgm-rev__icon').forEach(icon => {
                if (!icon.hasAttribute('aria-hidden')) {
                    icon.setAttribute('aria-hidden', 'true');
                    unpatchedFound = true;
                }
            });

            const summaryStars = pdpContainer.querySelector('.jdgm-rev-widg__summary-stars');
            if (summaryStars) {
                const label = summaryStars.getAttribute('aria-label');
                if (label && !label.includes('out of 5 stars')) {
                    summaryStars.setAttribute('aria-label', label + ' out of 5 stars');
                    unpatchedFound = true;
                }
            }

            if (!unpatchedFound) {
                observer.disconnect();
            }
        });

        observer.observe(pdpContainer, { childList: true, subtree: true });
    }
}

const cardLinks = () => {
    const card = document.querySelector(".card-link__card");
    const cardLink = document.querySelector(".card-link__link");

    card.addEventListener("click", () => {
    cardLink.click();
    })
}

const breadcrumbUpdates = () => {
  const path = window.location.pathname;
  const isCollection = path.startsWith("/collections/");

  let lastCollection = null;
  try {
    lastCollection = JSON.parse(localStorage.getItem("lastCollection"));
  } catch (e) {
    lastCollection = null;
  }
  const lastVisitedUrl = localStorage.getItem("lastVisitedUrl");

  if (isCollection) {
    const collectionUrl = path;
    const collectionTitle = (document.querySelector('.image-text-banner__heading')?.textContent || '').trim();
    const breadcrumbList = document.querySelector(".breadcrumbs__item")?.parentElement;

    // Show previous collection only if it was the immediate last page
    if (
      breadcrumbList &&
      lastCollection &&
      lastCollection.title &&
      lastCollection.url !== collectionUrl &&
      lastVisitedUrl === lastCollection.url
    ) {
      const li = document.createElement("li");
      li.className = "breadcrumbs__item";

      const a = document.createElement("a");
      a.className = "breadcrumbs__link";
      a.href = lastCollection.url;
      a.title = lastCollection.title;
      a.textContent = lastCollection.title;

      li.appendChild(a);
      breadcrumbList.insertBefore(li, breadcrumbList.lastElementChild);
    }

    // Always update lastCollection when on a collection page
    if (collectionTitle) {
      localStorage.setItem("lastCollection", JSON.stringify({
        url: collectionUrl,
        title: collectionTitle
      }));
    } else {
      localStorage.removeItem("lastCollection");
    }
  } else {
    localStorage.removeItem("lastCollection");
  }

  // Always update lastVisitedUrl (all pages)
  localStorage.setItem("lastVisitedUrl", path);
};

searchButton = () => {
    const container = document.querySelector('.header__search-container');
    const toggleButton = container.querySelector('.header__icon');
    const closeButton = container.querySelector('.search-modal__close-button');
    const overlay = container.querySelector('.modal-overlay');

    const openModal = () => {
        if (container.classList.contains('open')) return;
        container.classList.add('open');
        document.body.classList.add('overflow-hidden');

        trapFocus(container.querySelector('.search-modal__content'), toggleButton);

        document.addEventListener('click', outsideClickListener);
    };

    const closeModal = () => {
        if (!container.classList.contains('open')) return;
        container.classList.remove('open');
        document.body.classList.remove('overflow-hidden');

        removeTrapFocus(toggleButton);
        document.removeEventListener('click', outsideClickListener);
    };

    const outsideClickListener = (event) => {
        const content = container.querySelector('.search-modal__content');
        if (!content.contains(event.target) && !toggleButton.contains(event.target)) {
            closeModal();
        }
    };

    // Event listeners
    toggleButton.addEventListener('click', (e) => {
        e.stopPropagation();
        openModal();
    });

    closeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        closeModal();
    });

    overlay.addEventListener('click', (e) => {
        e.stopPropagation();
        closeModal();
    });

    document.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') closeModal();
    });
}
class SeparatedList extends HTMLElement {
    constructor() {
        super();
        const that = this;
        window.resize(() => {
            const items = that.querySelectorAll('li');
            items.forEach((item, itemIndex) => {
                const previousItem = items[itemIndex - 1];
                const nextItem = items[itemIndex + 1];
                item.classList.toggle('first-of-row', !previousItem || item.offsetTop !== previousItem.offsetTop);
                item.classList.toggle('last-of-row', !nextItem || item.offsetTop !== nextItem.offsetTop);
            });
        });
    }
}
customElements.define('separated-list', SeparatedList);

window.onload = () => {
    init();
};
